import React from 'react';
import cssStyles from 'components/ui/toggle/BlazeToggle.module.css';

/**
 * Custom toggle for the React Dropdown. It is needed just to have custom mark up.
 */
class BlazeToggle extends React.Component<any> {
  constructor(props: any, context: any) {
    super(props, context);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e: any) {
    e.preventDefault();
    this.props.onClick(e);
  }

  render() {
    const { id, style } = this.props;
    return (
      <button
        ref={this.props.innerRef}
        style={style != null ? style : undefined}
        disabled={this.props.disabled}
        type="button"
        onClick={this.handleClick}
        title={this.props.children as string}
        className={cssStyles.toggle + ' form-control custom-select'}
        id={id}
      >
        <span className={cssStyles.toggleValue}>{this.props.children}</span>
      </button>
    );
  }
}

export default React.forwardRef((props, ref) => <BlazeToggle innerRef={ref} {...props} />);
